import { render, staticRenderFns } from "./patientList.vue?vue&type=template&id=5bc2ee5e&scoped=true"
import script from "./patientList.vue?vue&type=script&lang=js"
export * from "./patientList.vue?vue&type=script&lang=js"
import style0 from "./patientList.vue?vue&type=style&index=0&id=5bc2ee5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc2ee5e",
  null
  
)

export default component.exports